import React from "react";
import { useSelector } from "react-redux";
import { FiSearch, FiBarChart2, FiDownload, FiUsers } from "react-icons/fi";
import HowsItWork from "../../assets/images/researchwire_light_background.webp";
import "../../styles/workflow.scss";

const getSteps = (reportCount) => [
  {
    id: 1,
    title: ["Search &", "Discover"],
    icon: <FiSearch className="step-icon-svg" />,
    desc: `Browse our extensive library of ${reportCount.toLocaleString()}+ reports or use our intelligent search to find exactly what you need.`,
  },
  {
    id: 2,
    title: ["Explore &", "Analyze"],
    icon: <FiBarChart2 className="step-icon-svg" />,
    desc: "Review detailed report summaries, table of contents, and key findings before making your decision.",
  },
  {
    id: 3,
    title: ["Download &", "Access"],
    icon: <FiDownload className="step-icon-svg" />,
    desc: "Purchase instantly and get immediate access to full reports in PDF, Excel, and interactive formats.",
  },
  {
    id: 4,
    title: ["Expert", "Consulting"],
    icon: <FiUsers className="step-icon-svg" />,
    desc: "Connect with our experts for tailored insights, deeper analysis, and strategic guidance.",
  },
];

const Workflow = () => {
  const { reports } = useSelector((state) => state.researchReports);
  const reportCount = reports && reports.length > 0 ? reports.length : 11;
  const steps = getSteps(reportCount);

  return (
    <section
      className="workflow-section position-relative"
      style={{
        backgroundImage: `url(${HowsItWork})`,
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container position-relative z-1">
        {/* Header Section */}
        <div className="workflow-header text-center">
          <h2>
            How It <span className="title-highlight">Works</span>
          </h2>
          <p className="subtitle mx-auto">
            Get the market intelligence you need in four simple steps
          </p>
        </div>

        {/* Content Section */}
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="workflow-content-wrapper">
              <div className="connecting-line-container">
                <div className="connecting-line">
                  <span className="line-dot start-dot"></span>
                  <span className="line-arrow arrow-1">
                    <svg
                      width="6"
                      height="10"
                      viewBox="0 0 6 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 9L5 5L1 1"
                        stroke="#6366f1"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="line-arrow arrow-2">
                    <svg
                      width="6"
                      height="10"
                      viewBox="0 0 6 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 9L5 5L1 1"
                        stroke="#6366f1"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="line-arrow arrow-3">
                    <svg
                      width="6"
                      height="10"
                      viewBox="0 0 6 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 9L5 5L1 1"
                        stroke="#6366f1"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="line-dot end-dot"></span>
                </div>
              </div>

              <div className="steps-row">
                {steps.map((step) => (
                  <div key={step.id} className="step-col">
                    <div className="step-item">
                      <div className="step-circle-wrapper">
                        <div className="step-circle">{step.icon}</div>
                      </div>
                      <div className="step-content">
                        <h4>
                          {step.title[0]}{" "}
                          <span className="title-highlight">{step.title[1]}</span>
                        </h4>
                        <p>{step.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Workflow;
